// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2fTaS","loaderOuter":"PageOverlayLoader_loaderOuter__34g21"};